import { DndProvider } from "react-dnd";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HTML5Backend } from "react-dnd-html5-backend";

import mnMN from "antd/lib/locale/mn_MN";
import { ConfigProvider as AntdConfigProvider, App as AntdApp } from "antd";
import { ProConfigProvider, createIntl } from "@ant-design/pro-provider";

import Routes from "./routes/index";
import { proMNLocale } from "./config";
import { StoreProvider } from "./contexts";
import NavigationScroll from "./routes/components/navigation-scroll";
import "./global.less";

createRoot(document.getElementById("root")!).render(
  <AntdConfigProvider locale={mnMN}>
    <AntdApp>
      <ProConfigProvider
        intl={createIntl("en", proMNLocale)}
        valueTypeMap={proMNLocale}
      >
        <BrowserRouter>
          <StoreProvider>
            <DndProvider backend={HTML5Backend}>
              <NavigationScroll>
                <Routes />
              </NavigationScroll>
            </DndProvider>
          </StoreProvider>
        </BrowserRouter>
      </ProConfigProvider>
    </AntdApp>
  </AntdConfigProvider>
);
